import {
  openRealNameVerifyPopup,
  RealNameVerifyMode,
} from '@tencent/met-component/lib/real-name-verify';
import { Button, Modal } from '@tencent/tea-component';
import { Data } from '@quickService/DashboardEventCheckBeforePublish';
import { isEmpty } from 'lodash-es';
import styles from './index.module.scss';

interface VerifyAlertProps {
  title: string;
  message: string;
  okText: string;
  cancelText: string;
  corpRealNameMeansList?: string[];
  isInBuffer?: boolean; // 是否在实名缓冲期内，缓冲期内暂不验证继续业务流程，缓冲期外不验证则终止业务流程
}

interface VerifyModalProps {
  onNotVerify: () => void; // 暂不验证回调
  onVerifySuccess?: () => void; // 验证成功回调
  alertInfo: VerifyAlertProps; // 弹框提示信息
}

export const realNameVerifyModal = async (props: VerifyModalProps) => {
  const { onNotVerify, onVerifySuccess, alertInfo } = props;
  const confirm = () => {
    openRealNameVerifyPopup({
      corp_real_name_means_list: alertInfo.corpRealNameMeansList || ['1', '2'],
      is_show_back_button: false,
      verify_mode: RealNameVerifyMode.BIND,
      onSuccess: onVerifySuccess,
    });
  };
  const cancel = () => {
    if (!alertInfo.isInBuffer) {
      return;
    }
    onNotVerify();
  };
  const btns = [
    <Button type="primary" onClick={confirm}>
      {alertInfo.okText}
    </Button>,
  ];
  if (alertInfo.isInBuffer) {
    btns.unshift(<Button onClick={cancel}>{alertInfo.cancelText}</Button>);
  }
  Modal.alert({
    className: styles['real-name-modal'],
    type: 'warning',
    message: alertInfo.title,
    description: alertInfo.message,
    buttons: btns,
    disableCloseIcon: true,
    maskClosable: false,
  });
};

/**
 * 从接口获取的错误信息转换为实名认证弹框提示信息
 *
 * @param info 传入的错误信息
 * @returns 实名认证弹框提示信息
 */
export const getRealNameAlertInfo = (info: Data['real_name_verify_info']): VerifyAlertProps => {
  const res: VerifyAlertProps = {
    title: '安全验证',
    message: '根据相关法律法规，请您完成相关身份核验。如不实名，将无法参加会议。',
    okText: '前往验证',
    cancelText: '暂不验证',
  };
  if (info) {
    res.message = info.content;
    res.isInBuffer = info.is_in_buffer;
    if (!isEmpty(info.corp_real_name_means_list)) {
      res.corpRealNameMeansList = info.corp_real_name_means_list;
    }
  }
  return res;
};
